import { envConfig } from "@configs/env";
import { CountryComponents, DeployCountry } from "@types";
import { getCountryComponent } from "@utils/countries";

const countryComponents: CountryComponents = {
  [DeployCountry.PH]: () => import("./components/PHBankAccountPage"),
  [DeployCountry.TH]: () => import("./components/THBankAccountPage"),
};
const WrappedBankAccountsPage = getCountryComponent(countryComponents, envConfig.countryCode);

export default WrappedBankAccountsPage;
